(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.handlers = {
    attach (context, settings) {

      // .filter-selection-topics a
      let filterTopics = once('filter-selection-topics', '.filter-selection-topics a', context);

      $(filterTopics).on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let vocabulary = $(this).data('vocabulary-name');
        let term = $(this).data('term-id');
        let selector = '[data-drupal-selector=' + vocabulary + ']';
        let multiSelector = selector + " option[value='" + term + "']";
        let selected = $(this).hasClass('selected');
        if (selected) {
          $(multiSelector).prop('selected', false);
          $(this).removeClass('selected').addClass('not-selected');
        } else {
          $(multiSelector).prop('selected', true);
          $(this).removeClass('not-selected').addClass('selected');
        }
        if (term !== 'All') {
          $('#selection-data-topics-All a', context).removeClass('selected').addClass('not-selected');
        }
      });

      // [data-drupal-selector="edit-field-topics"]
      let selectionTopics = once('data-drupal-selector-edit-field-topics', '[data-drupal-selector="edit-field-topics"]', context);
      if (selectionTopics.length > 0) {
        let topicsAll = true;
        let topicSelectedCount = 0;
        let topicCount = 0;
        $(selectionTopics).find('option').each(function() {
          topicCount = topicCount + 1;
          let selected = $(this).attr('selected');
          let tid = $(this).attr('value');
          if (selected !== 'undefined' && selected === 'selected') {
            topicSelectedCount = topicSelectedCount + 1;
            let topicSelection = '.filter-selection-topics [data-term-id="' + tid + '"]';
            $(topicSelection).removeClass('not-selected').addClass('selected');
          }
        });
        if (topicSelectedCount === 0 || topicSelectedCount === topicCount) {
          $('.filter-selection-topics a', context).each(function() {
            let tid = $(this).data('term-id');
            if (tid === 'All') {
              $(this).removeClass('not-selected').addClass('selected');
            } else {
              $(this).removeClass('selected').addClass('not-selected');
            }
          });
          $(selectionTopics).find('option').each(function() {
            $(this).prop('selected', false);
          });
        }
      }

      function getThisScreenWidth() {
        let hasSafariBrowser = window.matchMedia(`screen and (max-width: ${window.innerWidth-15}px)`).matches;
        let screenWidth = window.innerWidth;
        if (hasSafariBrowser) {
          screenWidth = screenWidth - 15;
        }
        return screenWidth;
      }

      function getSortOrder() {
        // [data-drupal-selector="edit-sort-by"]
        let sort = '';
        let order = '';
        let name = '';
        let sortBy = once('edit-sort-by', '[data-drupal-selector="edit-sort-by"]', context);
        if (sortBy.length > 0) {
          sort = $(sortBy).val();
        }

        // [data-drupal-selector="edit-sort-order"]
        let sortOrder = once('edit-sort-order', '[data-drupal-selector="edit-sort-order"]', context);
        if (sortOrder.length > 0) {
          order = $(sortOrder).val();
        }

        if (sortBy.length > 0 && sortOrder.length > 0) {
          let selector = "[data-sort-by-value=" + sort + "][data-sort-order-value=" + order + "]";
          $('#sort-by-radios a').each(function() {
            if ($(this).hasClass('option-selected')) {
              $(this).removeClass('option-selected').addClass('option-unselected');
              $(this).find('.icon').removeClass('icon-filter-checked').addClass('icon-filter-unchecked')
            }
          });
          if ($(selector).hasClass('option-unselected')) {
            $(selector).removeClass('option-unselected').addClass('option-selected');
            $(selector).find('.icon').removeClass('icon-filter-unchecked').addClass('icon-filter-checked');
            name = $(selector).data('sort-order-name');
            let screenWidth = getThisScreenWidth();
            let sortByButton = $('#sort-by-button');
            let displayName = $(sortByButton).find('.selection');
            $(displayName).text(name);
            if (screenWidth > 1400) {
              $(displayName).show();
            }
            else {
              $(displayName).hide();
            }
          }
          $('#page-highlighted-region').hide();
          let newsButtonSelector = '[data-drupal-selector=edit-submit-latest-news]';
          if ($(newsButtonSelector).length > 0) {
            $(newsButtonSelector).attr('value', 'Search');
          }
          let searchPage = $('.page-view-search');
          let searchString = '';
          if (searchPage.length > 0) {
            searchString = 'Search term';
          }
          else {
            searchString = 'Search news...';
          }
          $('#search-filters-container [data-drupal-selector=edit-search-api-fulltext]', context).attr('placeholder', searchString);
        }
      }

      getSortOrder();


      // #selection-data-topics-All a
      let selectionTopicsAll = once('data-drupal-selector-edit-field-topics-all', '#selection-data-topics-All a', context);
      if (selectionTopicsAll.length > 0) {
        $(selectionTopicsAll).on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          let debugging = false;
          if (debugging) {
            console.log('all clicked');
          }

          if (selectionTopics.length > 0) {
            $(selectionTopics).find('option').each(function() {
              $(this).prop('selected', false);
            });
          }
          // $(multiSelector).prop('selected', false);
          $('.filter-selection-topics a', context).each(function() {
            let tid = $(this).data('term-id');
            if (tid === 'All') {
              $(this).removeClass('not-selected').addClass('selected');
            } else {
              $(this).removeClass('selected').addClass('not-selected');
            }
          });
        });
      }

      // [data-drupal-selector="edit-field-media-category-1"]
      let selectionCategories = once('data-drupal-selector-edit-field-media-category', '[data-drupal-selector="edit-field-media-category"]', context);
      if (selectionCategories.length > 0) {
        let selectionValue = $(selectionCategories).val();
        let categorySelection = '.filter-selection-categories [data-term-id="' + selectionValue + '"]';
        $(categorySelection).removeClass('not-selected').addClass('selected');
      }

      let filterCategories = once('filter-selection-categories', '.filter-selection-categories a', context);
      $(filterCategories).on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let vocabulary = $(this).data('vocabulary-name');
        let term = $(this).data('term-id');
        let selector = '[data-drupal-selector=' + vocabulary + ']';
        $(selector, context).val(term).change();
        if ($(this).hasClass('not-selected')) {
          $(this).parents('ul').find('a').removeClass(['selected', 'not-selected']).addClass('not-selected')
          $(this).removeClass('not-selected').addClass('selected');
        }
      });

      // news-filters-show-results
      let newsFiltersShowResults = once('news-filters-show-results', '#news-filters-show-results', context);
      $(newsFiltersShowResults).on('click', function(e) {
        $('#page-highlighted-region').slideUp();
        $('#main-wrapper').slideUp();
        $('#search-filters-container').slideUp();
        $('.content-footer').slideDown();
        $('#search-filters-container #views-exposed-form-latest-news-block-2').submit();
      });

      // news-filters-show-results
      let searchFiltersShowResults = once('search-filters-show-results', '#search-filters-show-results', context);
      $(searchFiltersShowResults).on('click', function(e) {
        $('#page-highlighted-region').slideUp();
        $('#main-wrapper').slideUp();
        $('#search-filters-container').slideUp();
        $('.content-footer').slideDown();
        $('#search-filters-container #views-exposed-form-search-page-1').submit();
      });


      window.addEventListener('resize', function(){
        getSortOrder();
      },true);

    }

  };

})(jQuery, Drupal, once);
